var map = {
	"./1.jpg": 212,
	"./2.jpg": 1843,
	"./3.jpg": 8678,
	"./5.jpg": 4560,
	"./6.jpg": 8175,
	"./7.jpg": 242,
	"./8.jpg": 8953,
	"./9.jpg": 3580
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3939;